<template>
  <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <path d="M0 0h80v80H0z"/>
      <path d="M14.576 14.244V68.76c0 3.005 2.146 5.58 5.15 5.58h41.21c3.005 0 5.152-2.575 5.152-5.58V14.244H14.576zM14.03 31.415h51.573" stroke="#555" stroke-width="8"/>
      <g transform="translate(30.018 45.666)" fill="#555" fill-rule="nonzero">
        <circle cx="2.332" cy="3.031" r="3.332"/>
        <circle cx="10.521" cy="3.031" r="3.332"/>
        <circle cx="18.71" cy="3.031" r="3.332"/>
        <circle cx="2.332" cy="11.22" r="3.332"/>
        <circle cx="10.521" cy="11.22" r="3.332"/>
        <circle cx="18.71" cy="11.22" r="3.332"/>
      </g>
      <path d="M27.454 12.41V6.83M53.21 12.41V6.83" stroke="#555" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'IconCalendar'
  }
</script>
